import React, { useEffect, useState, useCallback } from "react";
import "@/App.css";
import "./styles/new-home.css";
import "./styles/pages.css";
import "./styles/header.css";
import "./styles/footer.css";
import "./styles/quiz.css";
import "./styles/workflows.css";
import "./styles/skye-bubble.css";
import "./styles/blog-post.css";
import "./styles/ai-chat.css";
import "./styles/case-studies.css";
import "./styles/admin-analytics.css";
import "./styles/admin-newsletter.css";
import "./styles/admin-blog.css";
import "./styles/privacy-policy.css";
import "./styles/trade-landing.css";
import "./styles/roi-calculator.css";
import "./styles/get-leads.css";
import "./styles/thank-you.css";
import "./styles/booking-modal.css";
import "./styles/simpletalk.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import NewHome from "./pages/NewHome";
import Features from "./pages/Features";
import HowItWorks from "./pages/HowItWorks";
import BlogPage from "./pages/BlogPage";
import BlogPost from "./pages/BlogPost";
import Quiz from "./pages/Quiz";
import Workflows from "./pages/Workflows";
import ProposalView from "./pages/ProposalView";
import NotFound from "./pages/NotFound";
import CaseStudies from "./pages/CaseStudies";
import AdminAnalytics from "./pages/AdminAnalytics";
import AdminNewsletter from "./pages/AdminNewsletter";
import AdminBlog from "./pages/AdminBlog";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Unsubscribe from "./pages/Unsubscribe";
import TradeLanding from "./pages/TradeLanding";
import ROICalculator from "./pages/ROICalculator";
import GetLeads from "./pages/GetLeads";
import ThankYou from "./pages/ThankYou";
import SimpleTalkAlternative from "./pages/SimpleTalkAlternative";
import AnalyticsTracker from "./components/AnalyticsTracker";
import BookingModal from "./components/BookingModal";
import { Toaster } from "./components/ui/sonner";

// Scroll to top component - handles route changes
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AppShell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');
  const isFunnel = pathname === '/getleads' || pathname === '/thank-you' || pathname === '/simpletalk-alternative';
  const [bookingOpen, setBookingOpen] = useState(false);

  const handleOpenBooking = useCallback(() => setBookingOpen(true), []);

  useEffect(() => {
    window.addEventListener('open-booking-modal', handleOpenBooking);
    return () => window.removeEventListener('open-booking-modal', handleOpenBooking);
  }, [handleOpenBooking]);

  return (
    <>
      <AnalyticsTracker />
      {!isAdmin && !isFunnel && <Header />}
      <main className="main-content">
        <Routes>
          <Route path="/" element={<NewHome />} />
          <Route path="/features" element={<Features />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/quiz" element={<Quiz />} />
          <Route path="/getleads" element={<GetLeads />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/simpletalk-alternative" element={<SimpleTalkAlternative />} />
          <Route path="/workflows" element={<Workflows />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/admin/analytics" element={<AdminAnalytics />} />
          <Route path="/admin/newsletter" element={<AdminNewsletter />} />
          <Route path="/admin/blog" element={<AdminBlog />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/unsubscribe/:token" element={<Unsubscribe />} />
          <Route path="/proposal/:proposalId" element={<ProposalView />} />
          <Route path="/roi-calculator" element={<ROICalculator />} />
          <Route path="/:tradeSlug" element={<TradeLanding />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      {!isAdmin && !isFunnel && <Footer />}
      <BookingModal isOpen={bookingOpen} onClose={() => setBookingOpen(false)} />
      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AppShell />
      </BrowserRouter>
    </div>
  );
}

export default App;
